import RangeFilters from './RangeFilters';

export default RangeFilters;
